let config = {
    title: `Breathing Blade: Destiny`,
    copyright: '© 2026 Ddembelyo',
    email: 'ddembelyoapp@gmail.com',
    policy: 'https://app.slayerbound.com/privacy_policy',
    term: 'https://app.slayerbound.com/terms.html',
    introduceTitle: [
        `Don't miss out on the ultimate tactical RPG experience! Join a thriving community, master powerful breathing techniques, and conquer formidable foes together. Your legend begins now!`,
    ],
    introduceText: [
        {
            title: '• ASSEMBLE YOUR ELITE SQUAD',
            text: [
                'Form an invincible team of diverse heroes, each possessing unique fighting styles and ancient powers. Strategize critical formations and leverage elemental synergies to dominate turn-based battles. Every member counts in your quest for supremacy.'
            ]
        },
        {
            title: '• COMMAND ANCIENT BREATHING ARTS',
            text: [
                `Uncover and perfect a vast array of specialized breathing forms. Train intensely to unlock advanced techniques and transform your warriors into forces of nature. The path to ultimate power awaits those dedicated to discipline.`
            ]
        },
        {
            title: '• STRATEGIC RESOURCE OPTIMIZATION',
            text: [
                `Collect and manage vital resources efficiently to power up your team. Enhance your armaments, acquire mystical artifacts, and develop your training grounds to prepare for every impending threat. Intelligent management is key to victory.`
            ]
        },
        {
            title: '• DEEP & CAPTIVATING STORYLINE',
            text: [
                `Embark on an epic narrative journey across a realm plagued by darkness. Unravel ancient mysteries, confront demonic entities, and shape the destiny of your world through your courageous deeds. Every chapter presents new challenges and revelations.`
            ]
        }
    ]
}
export default config;